import React from 'react';
import './BonusPromotion.css';

const BonusPromotion = () => {
  return (
 <div className="landing-container">
      {/* Header Section */}
      <div className="header-section-free">
        <h1 className="header-title">Trade Without Limits</h1>

      </div>

      {/* Bonus Promo Section */}
      <div className="promo-section">
        <img
          src={require("../../../assets/offer 1 asset .png")}
          alt="Trader"
          className="promo-image"
        />
        <div className="promo-text">
          <h2>Swap-Free.<br />
              Commission-Free.<br />
              100 % Transparent.
            </h2>
          <p>
            Overnight charges and hidden fees shouldn’t
            cost you your wins. With GivTrade’s swap-free
            account, your profits stay where they belong
            in your pocket.
          </p>
          <button className="claim-button" 
           onClick={() => window.location.href = 'https://accounts.giv.trade/marketing/links/go/5'}>GET MY BONUS NOW</button>
        </div>
      </div>

      {/* Mid Section */}
      <div className="mid-section">
        <div className="strategy-text">
          <h3>You've got the strategy.
              You've got the skills..</h3>
          <p>But fees are silently draining your earnings
            every night.</p>
        </div>
        <div className="smart-traders-box">
          <h3>GivTrade <br /> Swap-Free Account</h3>
          <p>is designed for real traders who hold
          positions and expect full
            transparency</p>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="benefits-section">
        <h2>
          No swaps. No commissions. No minimum deposit.
            <br />
          Just pure, unhindered trading.
        </h2>
        <div className="benefits-grid">
          <div className="benefits-column">
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>Swap-Free</strong><br />Hold overnight without being penalized</p>
            </div>
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>Keep every pip you earn</strong><br />Trade efficiently with tight pricing</p>
            </div>
          </div>
          <div className="benefits-column2">
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>$0 Commission</strong><br />Keep every pip you earn</p>
            </div>
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>Transparent Conditions</strong><br />No tricks, no hidden charges, ever</p>
            </div>
          </div>
        </div>
      </div>

      {/* Final Call-to-Action Section */}
      <div className="final-cta-section">
        <h2>
          Takes 60 seconds.<br />
          <strong>No deposit required to open an account.</strong>
        </h2>
        <button className="cta-button" 
         onClick={() => window.location.href = 'https://accounts.giv.trade/marketing/links/go/5'}>GET MY BONUS NOW</button>
      </div>
    </div>
  );
};

export default BonusPromotion;